export class PatientAnswer {
  id: number;
  surveyQuestionId: number;
  answerText: string;
  kind: string;
  isCustom: boolean;

  constructor() {}

  toApiV2() {
    return {
      id: this.id,
      survey_question_id: this.surveyQuestionId,
      answer_text: this.answerText,
      kind: this.kind,
      is_custom: this.isCustom,
    };
  }
}
